import { Outlet, useNavigate } from "react-router";
import { useState } from "react";
import type { ReactNode } from "react";

export function TrackingLayout({ children }: { children?: ReactNode }) {
  const navigate = useNavigate();
  const [inputTrackingNumber, setInputTrackingNumber] = useState("");

  const handleTrack = () => {
    if (inputTrackingNumber.trim()) {
      void navigate(`/tracking/${inputTrackingNumber.trim()}`);
      setInputTrackingNumber("");
    }
  };

  return (
    <div className="min-h-screen bg-background">
      <header className="border-b relative z-50 bg-white shadow-sm">
        <div className="container mx-auto max-w-6xl py-4 px-4 sm:px-0">
          <div className="flex flex-col sm:flex-row sm:justify-between gap-4">
            <h1 className="text-xl sm:text-2xl font-semibold text-foreground text-center sm:text-left">
              EZ Shipment Tracking
            </h1>
            {/* Desktop tracking form */}
            <div className="hidden sm:flex flex-col sm:flex-row gap-2 sm:gap-3 w-full sm:w-auto">
              <input
                type="text"
                value={inputTrackingNumber}
                onChange={(e) => setInputTrackingNumber(e.target.value)}
                placeholder="Enter tracking number"
                className="w-full sm:w-64 px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-primary/50 focus:border-primary"
              />
              <button
                onClick={handleTrack}
                className="w-full sm:w-auto px-4 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors"
              >
                Track
              </button>
            </div>

            {/* Mobile tracking form */}
            <div className="flex sm:hidden flex-col gap-3 w-full">
              <div className="relative">
                <input
                  type="text"
                  value={inputTrackingNumber}
                  onChange={(e) => setInputTrackingNumber(e.target.value)}
                  placeholder="Enter tracking number"
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/50 focus:border-primary text-base"
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      handleTrack();
                    }
                  }}
                />
              </div>
              <button
                onClick={handleTrack}
                className="w-full px-4 py-3 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-colors font-medium text-base shadow-sm"
              >
                Track
              </button>
            </div>
          </div>
        </div>
      </header>
      <main className="pb-12">{children ?? <Outlet />}</main>
    </div>
  );
}
